<template>
    <div  style="min-height: calc(100vh - 100px)">
        <div v-if="isload" style="height: 10px;">
            <b-progress :value="current_counter" :max="counter" animated></b-progress>
        </div>
        <CCard body-wrapper>
                <div style="padding-bottom: 5px;">{{ $t("Select date") }}</div>
                
                <div class="inline-block-table">
                    <div style="padding-bottom: 5px;">{{ $t("from") }}</div>
                    
                    <div style="width: 100px; float: left;">
                        <CSelect
                            :label="$t('year')"
                            :options="year_options"
                            :value.sync="selectedYear"
                            @update:value="selectYear"
                            :disabled="searched_flag"
                        >
                        </CSelect>
                    </div>
                    <div style="width: 75px; float: left; padding-left: 5px">
                        <CSelect
                            :label="$t('month')"
                            :options="month_options"
                            :value.sync="selectedMonth"
                            @update:value="selectMonth"
                            :disabled="searched_flag"
                        >
                        </CSelect>
                    </div>
                     <div style="width: 75px; float: left;padding-left: 5px">
                        <CSelect
                            :label="$t('day')"
                            :options="day_options"
                            :value.sync="selectedDay"
                            @update:value="selectDay"
                            :disabled="searched_flag"
                        >
                        </CSelect>
                        
                    </div>
                    
                </div>
                <div class="inline-block-table-right">

                    <div style="padding-bottom: 5px;">{{ $t('to') }}</div>
                    <div style="width: 100px; float: left;">
                        <CSelect
                            :label="$t('year')"
                            :options="year_options"
                            :value.sync="selectedYearTo"
                            @update:value="selectYearTo"
                            :disabled="searched_flag"
                        >
                        </CSelect>
                    </div>
                    
                    <div style="width: 75px; float: left; padding-left: 5px">
                        <CSelect
                            :label="$t('month')"
                            :options="monthTo_options"
                            :value.sync="selectedMonthTo"
                            @update:value="selectMonthTo"
                            :disabled="searched_flag"
                        >
                        </CSelect>
                    </div>
                    <div style="width: 75px; float: left;padding-left: 5px">
                        <CSelect
                            :label="$t('day')"
                            :options="dayTo_options"
                            :value.sync="selectedDayTo"
                            @update:value="selectDayTo"
                            :disabled="searched_flag"
                        >
                        </CSelect>
                        
                    </div>
                   
                    
                </div>
                <div style="display: table;">
                    <div style="padding-bottom: 5px;">{{ $t('League') }}</div>
                    <div style="width: 180px; float: left;">
                        <CSelect
                            :options="league_options"
                            :value.sync="selectedLeague"                            
                            :disabled="searched_flag"
                        >
                        </CSelect>
                        
                    </div>
                    <div v-if="!searched_flag" style="float: left; padding-left: 10px; padding-right: 10px">
                        <b-button style="float: left;" type="submit" variant="primary" @click="sendData" :disabled="!selectedYear || !selectedMonth || !selectedDay || !selectedYearTo || !selectedMonthTo || !selectedDayTo || !selectedLeague || searched_flag">{{ $t('Search') }}</b-button>
                    </div>
                    <div v-else style="float: left; padding-left: 10px; padding-right: 10px">
                        <b-button style="float: left;" type="submit" variant="danger" @click="reset" :disabled="!searched_flag">{{ $t('Reset') }}</b-button>
                    </div>
                </div>
                
            
            <b-form-group v-if="searched_flag">                
                <div class="inline-block-table" style="width: 200px;">
                    <CSelect
                        :options="team_options"
                        :label="$t('Team')"
                        :value.sync="selectedTeam"
                        @update:value="selectTeam"
                    >
                    </CSelect>
                </div>
                <div class="inline-block-table-right" style="width: 150px;">
                    <CSelect
                        :options="side_options"
                        :label="$t('Home/Away')"
                        :value.sync="selectedSide"
                        @update:value="selectSide"
                    >
                    </CSelect>
                </div>
            </b-form-group>
            <b-form-group v-if="team_selected_flag">                
                <div class="inline-block-table" style="width: 200px;">
                    <CSelect
                        :options="filtered_events"
                        :label="$t('Event Name')"
                        
                        @update:value="selectEvent"
                    >
                    </CSelect>
                </div>
                <div class="inline-block-table-right" style="width: 200px;">
                    <CSelect
                        :options="marketIds"
                        :label="$t('Market Name')"
                        :value.sync="selectedMarket"
                        @update:value="selectMarket"
                    >
                    </CSelect>
                </div>
            </b-form-group>
            <div style="padding: 10px;" v-if="team_selected_flag">
                <div>{{ $t('event Name') }}:  <label style="color: #3526b2">{{data.eventName}}</label></div>
                <div>{{ $t('event Id') }}:    <label style="color: #3526b2">{{data.eventId}}</label></div>
                <div>{{ $t('Market Id') }}:   <label style="color: #3526b2">{{data.marketId}}</label></div>
                <div>{{ $t('Market Type') }}: <label style="color: #3526b2">{{data.marketType}}</label></div>
                <div>{{ $t('League') }}:      <label style="color: #3526b2">{{data.league}}</label></div>
            </div>

            <div style="width: 88vw;display: flex; overflow-x: auto;">
                <!-- <b-col sm="3" style="float: left; background: lightgoldenrodyellow; width: 400px !important;"> -->
                <div style="background: lightgoldenrodyellow; padding-left: 20px; display: inline-block;">
                    <div v-for="(item1, index1) in data.marketsStats" :key="index1">
                        <div v-if="index1 == 0">{{ $t('Market Info') }}</div>
                        <div v-if="index1 == 0">{{$t(data.marketType)}}</div>
                        <div v-if="index1 == 0" style="display: flex;justify-content: space-between;"><span class="status_line">{{ $t('Status') }}</span><span class="inplay_line">{{ $t('InPlay') }}</span><span class="play_line"></span><span class="time_line">{{ $t('Time') }}</span></div>
                        <div  style="display: flex;justify-content: space-between;">
                            <span style="color: red; margin: 0;"  class="status_line">{{ $t(item1.status) }}</span><span style="color: red; margin: 0;" class="inplay_line" v-if="item1.inPlay">{{ $t('true') }}</span><span style="color: red; margin: 0;" class="inplay_line" v-else>{{ $t('false') }}</span><span class="play_line">{{ $t(item1.play) }}</span><span style="color: blue; margin: 0;" class="time_line">{{item1.minute}}'</span>
                        </div>
                    </div>
                </div>
                <div v-for="(item, index) in data.marketsData" :key="index" style="background: lightgoldenrodyellow; padding-left: 20px; display: inline-block; min-width: 150px;">
                    
                    <div v-if="index == 0 && data.marketType == 'MATCH_ODDS'">{{ $t('Home') }}</div>
                    <div v-else-if="index == 1 && data.marketType == 'MATCH_ODDS'">{{ $t('Away') }}</div>
                    <div v-else-if="index == 2 && data.marketType == 'MATCH_ODDS'">{{ $t('Draw') }}</div>

                    <div v-else-if="index == 0 && data.marketType == 'HALF_TIME'">{{ $t('Home HT') }}</div>
                    <div v-else-if="index == 1 && data.marketType == 'HALF_TIME'">{{ $t('Away HT') }}</div>
                    <div v-else-if="index == 2 && data.marketType == 'HALF_TIME'">{{ $t('Draw HT') }}</div>

                    <div v-else-if="index == 0 && data.marketType == 'FIRST_HALF_GOALS_05'">{{ $t('Under 0.5 HT') }}</div>
                    <div v-else-if="index == 1 && data.marketType == 'FIRST_HALF_GOALS_05'">{{ $t('Over 0.5 HT') }}</div>                    

                    <div v-else-if="index == 0 && data.marketType == 'OVER_UNDER_05'">{{ $t('Under 0.5') }}</div>
                    <div v-else-if="index == 1 && data.marketType == 'OVER_UNDER_05'">{{ $t('Over 0.5') }}</div>
                    <div v-else-if="index == 0 && data.marketType == 'OVER_UNDER_15'">{{ $t('Under 1.5') }}</div>
                    <div v-else-if="index == 1 && data.marketType == 'OVER_UNDER_15'">{{ $t('Over 1.5') }}</div>
                    <div v-else-if="index == 0 && data.marketType == 'OVER_UNDER_25'">{{ $t('Under 2.5') }}</div>
                    <div v-else-if="index == 1 && data.marketType == 'OVER_UNDER_25'">{{ $t('Over 2.5') }}</div>
                    <div v-else-if="index == 0 && data.marketType == 'OVER_UNDER_35'">{{ $t('Under 3.5') }}</div>
                    <div v-else-if="index == 1 && data.marketType == 'OVER_UNDER_35'">{{ $t('Over 3.5') }}</div>

                    <div>{{ $t('Runner Id') }}: {{item.selectionId}}</div>
                    <div v-for="(item1, index1) in item.markets_data" :key="index1">                       
                        <div v-if="index1 == 0"><span class="time_line">{{ $t('Price') }}</span></div>
                        <div>
                            <span style="color: blue; margin: 0;"  class="time_line">{{item1.price}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </CCard>
    </div>
</template>
<script>
    import { mapActions, mapGetters } from 'vuex';
    export default {
        name: 'HistoricDataUpload',
        components: {
        },
        data () {
            return {
                collapse: false,
                file: null,
                marketData:{

                },
                data: {
                    marketsStats: "",
                    marketsData: '',
                    finalData:'',
                    marketId: '',
                    eventId: '',
                    eventName: '',
                    marketType: '',
                    league: ''
                },
                counter: 100,
                current_counter: 0,
                daily_events: [],
                filtered_events: [],
                year_options: [],
                month_options: [],
                day_options: [],
                monthTo_options: [],
                dayTo_options: [],
                total_events: [],
                clock: null,
                isload: false,
                openDate: null,
                marketIds: [],
                total_date: [],
                selectedYear: '',
                selectedMonth: '',
                selectedDay: '',

                selectedYearTo: '',
                selectedMonthTo: '',
                selectedDayTo: '',
                searched_flag: false,
                selectedMarket: '',

                selectedLeague: "",
                league_options: [],
                team_options: [],
                side_options: [
                    { label: this.$t("Both"), value: "Both" },
                    { label: this.$t("Home"), value: "Home" },
                    { label: this.$t("Away"), value: "Away" },
                ],

                selectedTeam: "",
                selectedSide: "Both"

            }
        },
        methods: {
            ...mapActions([
                'getBetfairHistory_date',
                'getMarketData',
                'getBetfairHistoryDate'
            ]),
            selectTeam(evt) {
                this.selectedTeam = evt;
                this.filterEvents();
            },
            selectSide(evt) {
                this.selectedSide = evt;
                this.filterEvents();
            },
            filterEvents() {
                if ( this.selectedTeam ) {
                    if ( this.selectedSide == "Both" ) {
                        this.filtered_events = this.daily_events.filter ( item => item.home == this.selectedTeam || item.away == this.selectedTeam);
                    }
                    else if ( this.selectedSide == "Home" ) {
                        this.filtered_events = this.daily_events.filter ( item => item.home == this.selectedTeam);
                    }
                    else if ( this.selectedSide == "Away" ) {
                        this.filtered_events = this.daily_events.filter ( item => item.away == this.selectedTeam);
                    }

                    this.filtered_events.unshift({label: this.$t("select event"), value: ''});
                }
            },
            selectYear(evt) {
                this.month_options = [{label: "month", value: ""}];
                this.day_options = [];
                if (evt) {
                    let dateItems = this.total_date.filter( item => item.year == evt );
                    let month_options = [];
                    for ( var i=0; i<dateItems.length; i++ ) {
                        let dateItem = dateItems[i];
                        if ( !month_options.includes( dateItem.month ))
                            month_options.push(dateItem.month);
                    }

                    this.month_options = month_options;
                    this.selectedYear = evt;
                    this.selectMonth(month_options[0]);

                }

            },
            selectMonth(evt) {
                if (this.selectedYear && evt){
                    let dateItems = this.total_date.filter( item => item.year == this.selectedYear && item.month ==  evt );
                    let day_options = [];
                    for ( var i=0; i<dateItems.length; i++ ) {
                        let dateItem = dateItems[i];
                        if ( !day_options.includes( dateItem.day ))
                            day_options.push(dateItem.day);
                    }

                    this.selectedMonth = evt;
                    this.day_options = day_options;

                    this.selectDay(day_options[0]);
                }
            },
            selectDay(evt) {
                this.selectedDay = evt;
            },

            selectYearTo(evt) {
                this.monthTo_options = [{label: "month", value: ""}];
                this.dayTo_options = [];
                if (evt) {
                    let dateItems = this.total_date.filter( item => item.year == evt );
                    let month_options = [];
                    for ( var i=0; i<dateItems.length; i++ ) {
                        let dateItem = dateItems[i];
                        if ( !month_options.includes( dateItem.month ))
                            month_options.push(dateItem.month);
                    }

                    this.monthTo_options = month_options;
                    this.selectedYearTo = evt;
                    this.selectMonthTo(month_options[month_options.length - 1]);

                }

            },
            selectMonthTo(evt) {
                if (this.selectedYearTo && evt){
                    let dateItems = this.total_date.filter( item => item.year == this.selectedYearTo && item.month ==  evt );
                    let day_options = [];
                    for ( var i=0; i<dateItems.length; i++ ) {
                        let dateItem = dateItems[i];
                        if ( !day_options.includes( dateItem.day ))
                            day_options.push(dateItem.day);
                    }

                    this.selectedMonthTo = evt;
                    this.dayTo_options = day_options;

                    this.selectDayTo(day_options[day_options.length - 1]);
                }
            },
            selectDayTo(evt) {
                this.selectedDayTo = evt;
            },
            init() {
                clearInterval(this.clock); 
                this.isload = true;
                this.clock = setInterval(this.frame, 300);

                let total_date = [];
                let total_year = [];
                this.getBetfairHistoryDate().then((data) => {
                    let dateItems = data.data;
                    this.league_options = data.league;
                    this.league_options = this.league_options.filter( item => item != null );
                    this.league_options.unshift({
                        label: this.$t("select league"),
                        value: ""
                    });
                    console.log("data.league;", data.league.length)
                    
                    for ( var i=0; i<dateItems.length; i++ ) {
                        let dateItem = dateItems[i];
                        let splited = dateItem.split("-");
                        total_date.push({
                            year: splited[0],
                            month: splited[1],
                            day: splited[2]
                        })

                        if ( !total_year.includes( splited[0] ))
                            total_year.push(splited[0]);

                    }

                    this.year_options = total_year;
                    this.total_date = total_date;

                    this.isload = false;
                    clearInterval(this.clock);
                    this.current_counter = 0;

                    this.selectYear(total_year[0]);
                    this.selectYearTo(total_year[total_year.length - 1]);
                });
            },
            date_select(evt){
                this.openDate = evt;
            },
            selectEvent(evt){
                
                this.marketIds = [];
               
                if ( evt ) {
                    let marketIds = this.total_events.filter( item => item.eventId == evt );

                    let marketKeys = [
                        "MATCH_ODDS",
                        "HALF_TIME",
                        "FIRST_HALF_GOALS_05",
                        "OVER_UNDER_05",
                        "OVER_UNDER_15",
                        "OVER_UNDER_25",
                        "OVER_UNDER_35"
                    ];

                    for ( const key of marketKeys ){
                        let filtered = marketIds.filter( item => item.marketType == key );
                        if (filtered.length > 0) {
                            this.marketIds.push({
                                label: this.$t(filtered[0].marketType),
                                value: filtered[0].fileName
                            });
                        }
                    }

                    if ( this.marketIds.length > 0 ) {
                        this.marketIds.unshift({label: this.$t("select market"), value: ""});
                    }

                    this.selectedMarket = '';

                    this.data.marketsData = '';
                    this.data.finalData = '';
                    this.data.marketId = '';
                    this.data.eventId = '';
                    this.data.eventName = '';
                    this.data.marketType = '';

                    this.getLeague( parseInt(evt) );
                    // if (this.marketIds.length > 0) {
                    //     this.selectMarket(this.marketIds[0].value);
                    // }

                }


            },
            selectMarket(evt) {
                
                if (evt) {
                    this.data.marketsData = '';
                    this.data.finalData = '';
                    this.data.marketId = '';
                    this.data.eventId = '';
                    this.data.eventName = '';
                    this.data.marketType = '';
                    this.data.marketsStats = '';

                    clearInterval(this.clock); 
                    this.isload = true;
                    this.clock = setInterval(this.frame, 300);

                    let half_time_item = this.marketIds.filter( item => item.label == this.$t("HALF_TIME") );
                    if ( half_time_item.length > 0 ) {
                        this.getMarketData({ filePath: evt, half_time_path: half_time_item[0].value }).then((data) => {

                            console.log('data======>', data)
                            this.data.marketsData = data.data[0];
                            this.data.finalData = data.finalData;
                            this.data.marketId = data.data[1];
                            this.data.eventId = data.data[2];
                            this.data.eventName = data.data[3];
                            this.data.marketType = data.data[4];
                            this.data.marketsStats = data.data[5];

                            console.log("this.data.marketsStats", this.data.marketsStats)
                            // this.data.leagueName = data.leagueName;

                            this.isload = false;
                            clearInterval(this.clock);
                            this.current_counter = 0;
                        });
                    }
                }
            },
            getLeague(val){
                
                window.axios.post(`${process.env.VUE_APP_URL}getLeague`,[val]).then(({data})=>{
                    if(data.message === "success"){
                        this.data.league = data.data[0]                        
                    }
                    else{
                        // alert("can't find this event!")
                    }
                })
            },
            initData() {
                this.data = {
                    marketsStats: '',
                    marketsData: '',
                    finalData:'',
                    marketId: '',
                    eventId: '',
                    eventName: '',
                    marketType: '',
                    league: ''
                };
                
                this.daily_events = [];
                this.marketIds = [];
                
            },
            reset(){
                this.initData();
                this.searched_flag = false;
            },
            sendData() {
                this.initData();
                clearInterval(this.clock); 
                this.isload = true;
                this.clock = setInterval(this.frame, 300);

                let openDate = this.selectedYear + "-" + this.selectedMonth + "-" + this.selectedDay;
                let openDateTo = this.selectedYearTo + "-" + this.selectedMonthTo + "-" + this.selectedDayTo;

                this.getBetfairHistory_date({ openDate: openDate, openDateTo: openDateTo, leagueName: this.selectedLeague }).then((data) => {

                    this.total_events = data.data;

                    let eventIds = [];
                    let daily_events = [];

                    let team_options = [];
                    let total_team_names = [];

                    for ( var i=0; i<data.data.length; i++) {
                        
                        if ( !eventIds.includes(data.data[i].eventId) ) {
                            let homeName = data.data[i].eventName.split(" v ")[0];
                            let awayName = data.data[i].eventName.split(" v ")[1];
                            daily_events.push({
                                label: data.data[i].eventName + " " + data.data[i].openYMD,
                                value: data.data[i].eventId,
                                home: homeName,
                                away: awayName
                            });
                            eventIds.push(data.data[i].eventId);

                            if ( !total_team_names.includes(homeName) ) {
                                total_team_names.push(homeName);
                                team_options.push(homeName);
                            }
                            if ( !total_team_names.includes(awayName) ) {
                                total_team_names.push(awayName);
                                team_options.push(awayName);
                            }
                        }
                    }
                    team_options.sort();
                    team_options.unshift({label: this.$t("select team"), value: ''})

                    this.team_options = team_options;

                    this.isload = false;
                    clearInterval(this.clock);
                    this.current_counter = 0;

                    this.daily_events = daily_events;
                    this.searched_flag = true;
                    // if (daily_events.length > 0) {
                    //     this.selectEvent(daily_events[0].value);
                    // }
                });
            },
            frame() {
                if (this.current_counter >= 95) {
                    this.current_counter = 95
                    clearInterval(this.clock);
                } else {
                    this.current_counter++;

                    console.log('this.current_counter', this.current_counter)
                }
            },
            readFile(evt) {
                //console.log(evt.target.files)
                let file = evt
                var loader = new FileReader();
                var vm = this;
                loader.onload = function (loadEvent) {
                    if (loadEvent.target.readyState != 2)
                        return;
                    if (loadEvent.target.error) {
                        alert("Error while reading file " + file.name + ": " + loadEvent.target.error);
                        return;
                    }
                    function csvJSON(csv){
                        var lines = csv.split("\n");
                        console.log('==>', 'success-parsed!')
                        var eventId = 0
                        var eventName = ''
                        var marketId = 0
                        var marketType = ''
                        var runnerIds = []
                        var marketStartTime = ''
                        var marketEndTime = ''

                        let item = JSON.parse(lines[0])
                        // console.log(item, ' ,linesLength=>', lines.length)
                        let lastItem = JSON.parse(lines[lines.length - 2])
                        marketStartTime = lastItem.mc[0].marketDefinition.marketTime
                        marketEndTime = lastItem.mc[0].marketDefinition.settledTime
                        // console.log('lastItem=>', lastItem, marketStartTime, marketEndTime)
                        marketId = item.mc[0].id
                        
                        eventId = item.mc[0].marketDefinition.eventId
                        eventName = item.mc[0].marketDefinition.eventName
                        marketType = item.mc[0].marketDefinition.marketType
                        for(let r = 0 ; r < item.mc[0].marketDefinition.runners.length ; r++){
                            runnerIds[r] = item.mc[0].marketDefinition.runners[r].id
                        }

                        let market_array = []
                        for(let s = 0 ; s < runnerIds.length ; s++){
                            let markets = []
                            let check = 0
                            for(let i = 0; i < lines.length - 1; i++){
                                let item = JSON.parse(lines[i])
                                if(item.mc[0].marketDefinition){
                                    if(item.mc[0].marketDefinition.inPlay === true){
                                        check = 1
                                    }
                                }

                                if(item.mc[0].rc && check === 1){
                                    for(let ss = 0 ; ss < item.mc[0].rc.length ; ss++){
                                        if(item.mc[0].rc[ss].id === runnerIds[s] && item.mc[0].rc[ss].atb){
                                            markets.push({"pt": item.pt, "price": item.mc[0].rc[ss].atb[0][0], "id":item.mc[0].rc[ss].id})
                                        }
                                        else if(item.mc[0].rc[ss].id === runnerIds[s] && item.mc[0].rc[ss].ltp){
                                            markets.push({"pt": item.pt, "price": item.mc[0].rc[ss].ltp, "id":item.mc[0].rc[ss].id})
                                        }
                                    }
                                }
                            }
                            market_array.push({"runnerId": runnerIds[s], "markets": markets})
                        }

                        // console.log('Result=>', market_array)
                        let market_values = []
                        for(let i = 0 ; i < market_array.length ; i++){
                            let market_elem = []
                            let d1 = 0
                            for(let j = 0 ; j < market_array[i].markets.length - 1 ; j++) {
                                let marketDetail = market_array[i].markets[j]
                                let marketDetail1 = market_array[i].markets[j + 1]

                                if(j === 0){
                                    d1 = marketDetail.pt
                                }

                                var d = new Date(marketDetail.pt)
                                // var d1 = new Date(marketStartTime)
                                var diff = d - d1
                                var back = 0
                                var lay = 0

                                if (diff > 60e3){
                                    if(market_elem.length === 0){
                                        let price1 = marketDetail.price
                                        let price2 = marketDetail1.price
                                        if(price1 > price2){
                                            back = price2
                                            lay = price1
                                        }
                                        else{
                                            back = price1
                                            lay = price2
                                        }
                                        j = j + 2
                                        market_elem.push({'minute':Math.floor(diff / 60e3), 'back': back, 'lay': lay})
                                    }
                                    else if(Math.floor(diff / 60e3) > market_elem[market_elem.length - 1].minute){
                                        let price1 = marketDetail.price
                                        let price2 = marketDetail1.price
                                        if(price1 > price2){
                                            back = price2
                                            lay = price1
                                        }
                                        else{
                                            back = price1
                                            lay = price2
                                        }
                                        j = j + 2
                                        market_elem.push({'minute':Math.floor(diff / 60e3),  'back': back, 'lay': lay})
                                    }
                                }
                            }
                            market_values.push({"selectionId": market_array[i].runnerId, "markets_data": market_elem})
                        }
                        console.log(market_values)
                        // console.log('markets=>', marketId, eventId,eventName, marketType, runnerIds)
                        let market_values1 = []
                        for(let i = 0 ; i < market_values.length ; i++){
                            let markets1 = []
                            if(market_values[i].markets_data[0].minute > 1){
                                let elem1 = market_values[i].markets_data[0]
                                for(let k = 1 ; k < elem1.minute ; k++){
                                    markets1.push({"minute": k, "back": elem1.back, "lay": elem1.lay})
                                }
                            }
                            for(let j = 0 ; j < market_values[i].markets_data.length - 1 ; j++){
                                let elem1 = market_values[i].markets_data[j]
                                markets1.push(elem1)
                                let elem2 = market_values[i].markets_data[j + 1]
                                if(elem2.minute - elem1.minute > 1){
                                    for(let k = elem1.minute + 1 ; k < elem2.minute ; k++){
                                        markets1.push({"minute": k, "back": elem1.back, "lay": elem1.lay})
                                    }
                                }
                            }
                            market_values1.push({"selectionId": market_values[i].selectionId, "markets_data": markets1})
                        }
                        return [market_values1,marketId, eventId, eventName, marketType]; //JSON
                    }

                    let text = csvJSON(loadEvent.target.result)
                    let max = 0
                    let numbers = text[0].length
                    for(let i = 0 ; i < text[0].length ; i++){
                        let value = text[0][i].markets_data.length
                        if(value > max){
                            max = value
                        }
                    }

                    let market_final_data = []
                    for(let i = 0 ; i < max ; i++){
                        let runners = []
                        for(let j = 0 ; j < text[0].length ; j++){
                            let runnerId = text[0][j].selectionId
                            let runner = text[0][j].markets_data.filter(function(item) {
                                return item.minute === i + 1;
                            });
                            if(runner.length > 0){
                                runners.push({"selectionId": runnerId, "exchange": {"availableToBack":[{"price": runner[0].back, "size": 0}], "availableToLay":[{"price": runner[0].lay, "size": 0}]}})
                            }
                        }
                        market_final_data.push({"timeElapsed": i + 1, "elapsedRegularTime": i + 1, "runners": runners})
                    }

                    vm.data.marketsData = text[0],
                    vm.data.finalData = market_final_data
                    vm.data.marketId = text[1]
                    vm.data.eventId = text[2]
                    vm.data.eventName = text[3]
                    vm.data.marketType = text[4]
                    console.log('totalData=>', vm.data)
                };
                loader.readAsText(file)
            },
            sendData1(){
                window.axios.post(`${process.env.VUE_APP_URL}saveHistoricalData`,[this.data]).then(({data})=>{
                    console.log(data.message)
                    if(data.message == "success"){
                        console.log('toast!')
                        // this.makeToast('success')
                        alert("sucessfully parsed!")
                    }
                    else{
                        // this.makeToast('warning')
                        alert("sorry, something wrong.")
                    }
                })
            },
            makeToast(variant = null) {
                this.$bvToast.toast('Toast body content', {
                    title: `Variant ${variant || 'default'}`,
                    variant: variant,
                    solid: true
                })
            }
        },
        created() {
            this.init();
        },
        computed: {
            team_selected_flag() {
                if (this.searched_flag && this.selectedTeam)
                    return true;
                else
                    return false;
            },
            
        }
    }
</script>
<style scoped>
    .card{
        min-height: calc( 100vh - 80px);
    }
    .play_line {
        width: 120px;
        display: inline-block;
    }
    .time_line {
        width: 80px;
        display: inline-block;
    }
    .status_line {
        width: 105px;
        display: inline-block;
    }
    .inplay_line {
        width: 80px;
        display: inline-block;
    }
    .inline-block-table {
        display: inline-block;
    }
    .inline-block-table-right {
        display: inline-block; 
        padding-left: 10px;
    }
    @media (max-width: 576px) {
        .inline-block-table {
            display: table;
        }
        .inline-block-table-right {
            display: table;
            padding-left: 0px;
        }
    }
</style>
